enum VatReturnStatus{
    Open= 2, Closed, Deleted
}

export default VatReturnStatus;